import styles from './AuthContent.module.scss';
import { Button, PasswordInput } from '../../index';
import { Form, message } from 'antd';
import { Input } from '../../index';
import { useAppDispatch } from '../../../store/hooks';
import { login } from '../../../store/userSlice';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { COCKTAILS_PAGE } from '../../../lib';

type AuthFormT = {
  email: string;
  password: string;
};

const AuthContent = ({ logIn }: { logIn: () => void }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsloading] = useState<boolean>(false);

  const authUser = async (values: AuthFormT) => {
    setIsloading(true);
    const response: any = await dispatch(login(values));
    if (response === 200) {
      navigate(COCKTAILS_PAGE);
      logIn();
    } else {
      message.error('Password or email wrong!');
    }

    setIsloading(false);
  };

  return (
    <>
      <div className={styles.auth__title}>Authorization</div>
      <Form name="auth" onFinish={authUser} autoComplete="off">
        <Input name="email" placeholder="Email" errorMessage='Field "Email" is required' />
        <PasswordInput
          name="password"
          placeholder="Password"
          errorMessage='The "Password" field is required'
        />

        <Button label="Sign in" htmlType="submit" loading={isLoading} />
      </Form>
    </>
  );
};

export default AuthContent;
